import App from './app';
import createHistory from 'history/createBrowserHistory';
import scroll from 'smoothscroll-polyfill';
import createStore from './store/create';
import decorateHistoryWithAnalytics from './utils/googleAnalytics';
import DOM from 'react-dom';
import React from 'react';
import { loadableReady } from '@loadable/component';

(async function() {
  if (window.location.host === 'webcache.googleusercontent.com') return;
  scroll.polyfill();
  loadableReady(() => {
    const history = createHistory();
    const browserHistory = decorateHistoryWithAnalytics(history);
    const store = createStore(JSON.parse(window.__INITIAL_STATE__) || {}, browserHistory);
    DOM.hydrate(<App store={store} history={history} />, document.getElementById('root'));
  });
})();
